const Type = {
    audioVideoAd: 'audioVideoAd',
    instream: 'instream',
};
const ErrorTypes = {
    AD_LOAD: 'adLoadError',
    AD_PLAY: 'adPlayError',
    AD_PLAY_START_TIMEOUT: 'adPlayStartTimeoutError',
    AD_NO_FILL: 'adNoFill',
};
const Media = {
    video: 'video',
    audio: 'audio',
    display: 'display',
};
const Status = {
    eligibilityDecided: 'eligibilityDecided',
    amazonKeywordsRequestFailed: 'amazonKeywordsRequestFailed',
    requested: 'requested',
    response: 'response',
    loaded: 'loaded',
    loading: 'loading',
    failed: 'failed',
    viewable: 'viewable',
    refresh: 'refresh',
    started: 'started',
    playing: 'playing',
    progress: 'progress',
    paused: 'paused',
    skipped: 'skipped',
    resumed: 'resumed',
    stopped: 'stopped',
    firstQuartile: 'firstQuartile',
    midPoint: 'midPoint',
    thirdQuartile: 'thirdQuartile',
    ended: 'ended',
    allEnded: 'allEnded',
    error: 'error',
    volume: 'volume',
    setLearnMore: 'setLearnMore',
    requestInstreamAds: 'requestInstreamAds',
    updateInstreamParams: 'updateInstreamParams',
};
const Logging = {
    error: 'error',
    info: 'info',
};
const AmazonKeywordsErrorCodes = {
    REQUEST_FAILED: '85',
    EMPTY_PARAMS: '87',
};
const AmazonKeywordsErrorDescriptions = {
    REQUEST_FAILED: 'Amazon keywords request failed.',
    EMPTY_PARAMS: 'No parameters received.',
};
export default {
    Type,
    Media,
    Status,
    Logging,
    ErrorTypes,
    AmazonKeywordsErrorCodes,
    AmazonKeywordsErrorDescriptions,
};
